<template>
    <div class="app-inner fixed fixed-head-2 indexs">
        <!--/-->
        <div class="app-head">
            <common-header></common-header>
            <common-nav></common-nav>
        </div>
        <!--/-->
        <div class="app-body" infinite-scroll-disabled="true" infinite-scroll-distance="10">
            <my-bscroll>
                <div class="app-body-container" style="padding-bottom: 30px">

                    <!--今日工作等-->
                    <el-row class="mg-t-10">
                        <el-col :span="24">
                            <el-card shadow="hover" class="mycard-a today-job-card" v-loading="tasks_loading" body-style="padding-top:12px">
                                <span class="mycard-title" style="float:left;margin-top:8px;line-height:36px; ">今日工作</span>
                                <div style="margin-left:105px;margin-right:230px;">
                                    <el-button v-for="(item,idx) in tasks"
                                           :key="idx"
                                           class="mybtn-sm"
                                           :class="getTaskBtn(idx)"
                                           @click="xTo({path:'/monitor/task',query:{type:item.type}})"
                                           style="margin:0;margin-top:8px;margin-right:8px"
                                    >{{item.name}}</el-button>

                                  <el-tooltip class="jobbtn_s" effect="dark" :content="tasks_isStart==1?'结束所有工作任务':'开始所有工作任务'" placement="top">
                                    <div class="tasks_isStarts">
                                      <el-button class="mybtn-sm mybtn-blue2" @click="doWork(tasks_isStart)" plain>{{tasks_isStart==1?'结束工作':'开始工作'}}</el-button>
                                    </div>
                                  </el-tooltip>
                                </div>
                                <router-link tag="div" to="/monitor/task" class="jobbtn">去布置任务</router-link>
                                <div style="clear:both"></div>
                            </el-card>
                        </el-col>
                    </el-row>

                    <!--昨日概况等-->
                    <el-row class="mg-t-10">
                        <el-col :span="24">
                            <el-card shadow="hover" class="mycard-a">
                                <div class="mycard-title">
                                    昨日概况（{{getYesterday() | formatDate('yyyy-MM-dd')}}）
                                    <el-button @click="seeDay">查看日报</el-button>
                                </div>
                                <div class="ys-info">
                                    <div class="ys-info-item">
                                        <div class="ys-num">{{ys.saleAmount.total_data|formatMoney}}</div>
                                        <div class="ys-title">总销售额</div>
                                        <!--/-->
                                        <div class="ys-time" :class="getPctDirect(ys.saleAmount.day_direct)">
                                            <span class="t-l">日</span>
                                            <span class="t-r">
                                                <img src="@/assets/up.png" class="img-up">
                                                <img src="@/assets/down.png"class="img-down">
                                                <span class="pct">{{ys.saleAmount.day_ratio}}%</span>
                                            </span>
                                        </div>
                                        <div class="ys-time" :class="getPctDirect(ys.saleAmount.week_direct)">
                                            <span class="t-l">周</span>
                                            <span class="t-r">
                                                <img src="@/assets/up.png" class="img-up">
                                                <img src="@/assets/down.png"class="img-down">
                                                <span class="pct">{{ys.saleAmount.week_ratio}}%</span>
                                            </span>
                                        </div>
                                        <div class="ys-time" :class="getPctDirect(ys.saleAmount.month_direct)">
                                            <span class="t-l">月</span>
                                            <span class="t-r">
                                                <img src="@/assets/up.png" class="img-up">
                                                <img src="@/assets/down.png"class="img-down">
                                                <span class="pct">{{ys.saleAmount.month_ratio}}%</span>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="ys-info-item">
                                        <div class="ys-num">{{ys.payedAmount.total_data|formatMoney}}</div>
                                        <div class="ys-title">实收金额</div>
                                        <!--/-->
                                        <div class="ys-time" :class="getPctDirect(ys.payedAmount.day_direct)">
                                            <span class="t-l">日</span>
                                            <span class="t-r">
                                                <img src="@/assets/up.png" class="img-up">
                                                <img src="@/assets/down.png"class="img-down">
                                                <span class="pct">{{ys.payedAmount.day_ratio}}%</span>
                                            </span>
                                        </div>
                                        <div class="ys-time" :class="getPctDirect(ys.payedAmount.week_direct)">
                                            <span class="t-l">周</span>
                                            <span class="t-r">
                                                <img src="@/assets/up.png" class="img-up">
                                                <img src="@/assets/down.png"class="img-down">
                                                <span class="pct">{{ys.payedAmount.week_ratio}}%</span>
                                            </span>
                                        </div>
                                        <div class="ys-time" :class="getPctDirect(ys.payedAmount.month_direct)">
                                            <span class="t-l">月</span>
                                            <span class="t-r">
                                                <img src="@/assets/up.png" class="img-up">
                                                <img src="@/assets/down.png"class="img-down">
                                                <span class="pct">{{ys.payedAmount.month_ratio}}%</span>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="ys-info-item">
                                        <div class="ys-num">{{ys.profitAmount.total_data|formatMoney}}</div>
                                        <div class="ys-title">毛利润</div>
                                        <!--/-->
                                        <div class="ys-time" :class="getPctDirect(ys.profitAmount.day_direct)">
                                            <span class="t-l">日</span>
                                            <span class="t-r">
                                                <img src="@/assets/up.png" class="img-up">
                                                <img src="@/assets/down.png"class="img-down">
                                                <span class="pct">{{ys.profitAmount.day_ratio}}%</span>
                                            </span>
                                        </div>
                                        <div class="ys-time" :class="getPctDirect(ys.profitAmount.week_direct)">
                                            <span class="t-l">周</span>
                                            <span class="t-r">
                                                <img src="@/assets/up.png" class="img-up">
                                                <img src="@/assets/down.png"class="img-down">
                                                <span class="pct">{{ys.profitAmount.week_ratio}}%</span>
                                            </span>
                                        </div>
                                        <div class="ys-time" :class="getPctDirect(ys.profitAmount.month_direct)">
                                            <span class="t-l">月</span>
                                            <span class="t-r">
                                                <img src="@/assets/up.png" class="img-up">
                                                <img src="@/assets/down.png"class="img-down">
                                                <span class="pct">{{ys.profitAmount.month_ratio}}%</span>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="ys-info-item">
                                        <div class="ys-num">{{ys.orderNumber.total_data|formatNumber}}</div>
                                        <div class="ys-title">订单量</div>
                                        <!--/-->
                                        <div class="ys-time" :class="getPctDirect(ys.orderNumber.day_direct)">
                                            <span class="t-l">日</span>
                                            <span class="t-r">
                                                <img src="@/assets/up.png" class="img-up">
                                                <img src="@/assets/down.png"class="img-down">
                                                <span class="pct">{{ys.orderNumber.day_ratio}}%</span>
                                            </span>
                                        </div>
                                        <div class="ys-time" :class="getPctDirect(ys.orderNumber.week_direct)">
                                            <span class="t-l">周</span>
                                            <span class="t-r">
                                                <img src="@/assets/up.png" class="img-up">
                                                <img src="@/assets/down.png"class="img-down">
                                                <span class="pct">{{ys.orderNumber.week_ratio}}%</span>
                                            </span>
                                        </div>
                                        <div class="ys-time" :class="getPctDirect(ys.orderNumber.month_direct)">
                                            <span class="t-l">月</span>
                                            <span class="t-r">
                                                <img src="@/assets/up.png" class="img-up">
                                                <img src="@/assets/down.png"class="img-down">
                                                <span class="pct">{{ys.orderNumber.month_ratio}}%</span>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="ys-info-item">
                                        <div class="ys-num">{{ys.returnNumber.total_data|formatNumber}}</div>
                                        <div class="ys-title">退单量</div>
                                        <!--/-->
                                        <div class="ys-time" :class="getPctDirect(ys.returnNumber.day_direct)">
                                            <span class="t-l">日</span>
                                            <span class="t-r">
                                                <img src="@/assets/up.png" class="img-up">
                                                <img src="@/assets/down.png"class="img-down">
                                                <span class="pct">{{ys.returnNumber.day_ratio}}%</span>
                                            </span>
                                        </div>
                                        <div class="ys-time" :class="getPctDirect(ys.returnNumber.week_direct)">
                                            <span class="t-l">周</span>
                                            <span class="t-r">
                                                <img src="@/assets/up.png" class="img-up">
                                                <img src="@/assets/down.png"class="img-down">
                                                <span class="pct">{{ys.returnNumber.week_ratio}}%</span>
                                            </span>
                                        </div>
                                        <div class="ys-time" :class="getPctDirect(ys.returnNumber.month_direct)">
                                            <span class="t-l">月</span>
                                            <span class="t-r">
                                                <img src="@/assets/up.png" class="img-up">
                                                <img src="@/assets/down.png"class="img-down">
                                                <span class="pct">{{ys.returnNumber.month_ratio}}%</span>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="ys-info-item">
                                        <div class="ys-num">{{ys.customerNumber.total_data|formatNumber}}</div>
                                        <div class="ys-title">交易客户数</div>
                                        <!--/-->
                                        <div class="ys-time" :class="getPctDirect(ys.customerNumber.day_direct)">
                                            <span class="t-l">日</span>
                                            <span class="t-r">
                                                <img src="@/assets/up.png" class="img-up">
                                                <img src="@/assets/down.png"class="img-down">
                                                <span class="pct">{{ys.customerNumber.day_ratio}}%</span>
                                            </span>
                                        </div>
                                        <div class="ys-time" :class="getPctDirect(ys.customerNumber.week_direct)">
                                            <span class="t-l">周</span>
                                            <span class="t-r">
                                                <img src="@/assets/up.png" class="img-up">
                                                <img src="@/assets/down.png"class="img-down">
                                                <span class="pct">{{ys.customerNumber.week_ratio}}%</span>
                                            </span>
                                        </div>
                                        <div class="ys-time" :class="getPctDirect(ys.customerNumber.month_direct)">
                                            <span class="t-l">月</span>
                                            <span class="t-r">
                                                <img src="@/assets/up.png" class="img-up">
                                                <img src="@/assets/down.png"class="img-down">
                                                <span class="pct">{{ys.customerNumber.month_ratio}}%</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </el-card>
                        </el-col>
                    </el-row>

                    <!--畅销商品等-->
                    <el-row class="goods-type">
                        <div class="goods-type-item">
                            <el-card shadow="hover" class="mycard-a" v-loading="gd_loading">
                                <div class="mycard-title">畅销商品</div>
                                <ul class="goods-list">
                                    <li v-for="(item,idx) in gd.sellWell">
                                        <span class="num">{{idx+1}}</span> {{item}}
                                    </li>
                                </ul>
                            </el-card>
                        </div>
                        <div class="goods-type-item">
                            <el-card shadow="hover" class="mycard-a" v-loading="gd_loading">
                                <div class="mycard-title">滞销商品</div>
                                <ul class="goods-list">
                                    <li v-for="(item,idx) in gd.sellSlow">
                                        <span class="num">{{idx+1}}</span> {{item}}
                                    </li>
                                </ul>
                            </el-card>
                        </div>
                        <div class="goods-type-item">
                            <el-card shadow="hover" class="mycard-a" v-loading="gd_loading">
                                <div class="mycard-title">缺货商品</div>
                                <ul class="goods-list">
                                    <li v-for="(item,idx) in gd.stockout">
                                        <span class="num">{{idx+1}}</span> {{item}}
                                    </li>
                                </ul>
                            </el-card>
                        </div>
                        <div class="goods-type-item">
                            <el-card shadow="hover" class="mycard-a" v-loading="gd_loading">
                                <div class="mycard-title">临期商品</div>
                                <ul class="goods-list">
                                    <li v-for="(item,idx) in gd.expiration">
                                        <span class="num">{{idx+1}}</span> {{item}}
                                    </li>
                                </ul>
                            </el-card>
                        </div>
                        <div class="goods-type-item">
                            <div class="g-item-top">
                                <el-card shadow="hover" class="mycard-a">
                                    <div class="goods-last-title">总库存成本</div>
                                    <div class="goods-last-num">{{gd.goods.stockCost|formatCurrency('￥',2)}}</div>
                                </el-card>
                            </div>
                            <div class="g-item-bottom">
                                <el-card shadow="hover" class="mycard-a">
                                    <div class="goods-last-title">总商品数量</div>
                                    <div class="goods-last-num">{{gd.goods.total|formatNumber}}</div>
                                </el-card>
                            </div>
                        </div>
                    </el-row>

                    <!--订单提醒等-->
                    <el-row class="tips-type">
                        <div class="tips-type-item">
                            <el-card shadow="hover" class="mycard-b mycard-b-style1" style="min-height: 395px"  v-loading="orderWarn_loading">
                               <div class="mycard-title">订单提醒 <span v-if="orderWarn.noRead>0">（{{orderWarn.noRead}}）</span></div>
                                <div class="tx-list">

                                    <div class="tx-item" v-for="(item) in orderWarn.list">
                                        <div style="position: absolute;left: 0px;top: 0px;width: 92px;text-align: center;line-height: 92px;cursor:pointer" @click="$router.push('/order/error')">
                                            <span :style="item.num>0?'color:red':'color:#8fa7d7'">
                                                {{item.num}}
                                            </span>
                                        </div>
                                        <div class="tx-tag" style="padding-left: 92px">{{item.type}}</div>
                                        <div class="tx-title" style="padding: 2px 0;padding-left: 92px;color: #333">{{item.content}}</div>
                                    </div>

                                </div>
                            </el-card>
                        </div>
                        <div class="tips-type-item">
                            <el-card shadow="hover" class="mycard-b mycard-b-style2"  style="min-height: 395px"  v-loading="stockWarn_loading">
                               <div class="mycard-title">库存提醒 <span v-if="stockWarn.noRead>0">（{{stockWarn.noRead}}）</span></div>
                                <div class="tx-list">

                                    <div class="tx-item" :class="item.isRead=='1'?'':'active'"  v-for="(item) in stockWarn.list">
                                        <div class="tx-tag">#{{item.typeStr}}</div>
                                        <div class="tx-title">{{item.content}}</div>
                                        <div class="tx-body">异常数：{{item.errorNumber}} <span class="f-right">{{item.warnTime}}</span></div>
                                    </div>

                                </div>
                            </el-card>
                        </div>
                        <div class="tips-type-item">
                            <el-card shadow="hover" class="mycard-b mycard-b-style3"  style="min-height: 395px"  v-loading="reportWarn_loading">
                               <div class="mycard-title">报表提醒 <span v-if="reportWarn.noRead>0">（{{reportWarn.noRead}}）</span></div>
                                <div class="tx-list">

                                    <div class="tx-item"  :class="item.isRead=='1'?'':'active'"  v-for="(item) in reportWarn.list">
                                        <div class="tx-tag">#{{item.typeStr}}</div>
                                        <div class="tx-title">{{item.content}}</div>
                                        <div class="tx-body">销售额{{item.salesAmount|formatMoney}}，利润+{{item.profitAmount|formatMoney}}</div>
                                    </div>

                                </div>
                            </el-card>
                        </div>
                    </el-row>

                </div>
            </my-bscroll>
        </div>

        <el-dialog
          title=" C-Lodop "
          :visible.sync="dialogVisible"
          width="30%" class="mydialog" :append-to-body="true">
          打印控件未安装!点击这里
          <a href='http://static.sysale.net/static/plugins/lodop/CLodop_Setup_for_Win32NT.exe' target='_self'>执行安装</a>
          ,安装后请刷新该页面或重新进入。
        </el-dialog>
    </div>
</template>

<script>
  import ElCol from "element-ui/packages/col/src/col";
  import ElRow from "element-ui/packages/row/src/row";
  import {getLodop,getLodops} from '../../common/LodopFuncs.js';
export default {
  components: {
    ElRow,
    ElCol},
  data: function () {
        return {
          a_href:'',
          task_s:[],
          tasks_isStart:0,
          dialogVisible:false,
            // 今日工作
            tasks:[],
            tasks_loading:false,
            // 昨日概况
            ys: {
                "saleAmount": {},   // 销售额
                "payedAmount": {},   // 实收金额
                "profitAmount": {}, // 毛利润
                "orderNumber": {},  // 订单量
                "returnNumber": {}, // 退单量
                "customerNumber": {}// 客户数
            },
            // 商品
            gd:{
                sellWell:[],   // 畅销商品
                sellSlow:[],   // 滞销商品
                stockout:[],   // 缺货商品
                expiration:[], // 临期商品
                goods:{ },      // 总量
            },
            gd_loading:false,
            // 订单提醒
            orderWarn:{
                list:[],
                noRead:0
            },
            orderWarn_loading:false,
            // 库存提醒
            stockWarn:{
                list:[],
                noRead:0
            },
            stockWarn_loading:false,
            // 报表提醒
            reportWarn:{
                list:[],
                noRead:0
            },
            reportWarn_loading:false,
            yesterday:'',
        }
    },
    methods: {
      seeDay(){
        localStorage.setItem("yesterday",this.yesterday);
        this.xTo({path:'/report/daily'});
      },
      doWork: function(isStart){
        let self = this;
//        console.log(isStart)
        self.xEui.alert('', '确定要' + (isStart != 1 ? '开始工作' : '结束工作') + '吗？', function () {
          self.xEui.myloading(isStart != 1 ? '开启中...' : '关闭中...');
          self.xFetch.post(self.xApi('/robot/task/setStart'), {
            isStart: isStart == 1? 0 : 1
          },{xPostType:'form'}).then(function (res) {
            self.xEui.loading_close()
            if (res.data.code != '00') {
              self.xEui.msg_error(res.data.text)
              return
            }
            self.xEui.msg_success('操作成功')
            self.loadTasks();
          });
        })
      },
      loadTasks: function (cb) {
        let self = this;
        self.tasks_loading = true
        self.xFetch.post(self.xApi('/robot/task/getTask'), {}).then(function (res) {
          self.tasks_loading = false
//          console.log(res)
          if (res.data.code != '00') {
            self.xEui.msg_error(res.data.text)
            self.tasks = []
            self.tasks_isStart = 0
          }
          else{
            let arr = [];
            if(res.data.data.isStart == 1&&res.data.data.details&&res.data.data.details.length){
                for(let i of res.data.data.details){
                    if(i.isStart === 1){
                        arr.push(i);
                    }
                }
            }
            self.tasks = arr;
            self.tasks_isStart = res.data.data.isStart == 1 ? 1 : 0;
          }
          self.$nextTick(function () {
            cb && cb()
          })
        });
      },
      //订单机器人打印订单
        printDel:function(){
          let _this = this;
          let user = localStorage.getItem('sysale-robot$user');
          user = JSON.parse(user);
          setTimeout(()=>{
              if(!getLodops()){
                _this.xFetch.post(_this.xApi('/xx_admin/rbt.AutoDeal/sign?sessionid='+user.data.sessionid), {channel: 'PRINT_ROBOT_ORDER'}).then(function (res) {
                  if(res.data.ret_status === 'ok'){
//                    console.log(res)
                    let comet = new iComet({
                      channel : res.data.cname,
                      token:res.data.token,
                      subUrl :'http://corp.hixiaoxiao.com'+'/icomet/sub',//'http://test.hixiaoxiao.com:6081' '//corp.hixiaoxiao.com'
                      callback : function (content, type) {
//                      console.log(content, type)
                        content = JSON.parse(content);
                        //订单提示语音
                        let obj = {id: content.id, order_no: content.order_no};
                        _this.xFetch.post(_this.xApi("/xxtask/webprint/"+content.id+"/deal?sessionid="+user.data.sessionid), {channel: 'PRINT_ORDER'}).then(function (rex) {
                          let print_set = rex.data;
//                         console.log(rex)
                          LODOP = getLodop(document.getElementById("LODOP_OB")
                            ,document.getElementById("LODOP_EM"));
                          LODOP.PRINT_INIT("");
                          if(print_set.prt_type==1){
                            LODOP.ADD_PRINT_HTM(0,10,"100%","100%",print_set.html);
                            LODOP.SET_PRINT_PAGESIZE(1,(print_set.print_w*100).toFixed(0),(print_set.print_h*100).toFixed(0),"");
                          }else if(print_set.prt_type==2){
                            LODOP.ADD_PRINT_HTM(0,10,"100%","100%",print_set.html);
                            LODOP.SET_PRINT_PAGESIZE(3,(print_set.printW*100).toFixed(0),85,"");
                          }else if(print_set.prt_type==4){
                            LODOP.ADD_PRINT_TABLE(0,10,"100%","100%",print_set.html);
                            LODOP.SET_PRINT_STYLEA(0,"TableHeightScope",1);
                            LODOP.SET_PRINT_PAGESIZE(4,(print_set.print_w*100).toFixed(0),(print_set.print_h*100).toFixed(0),"");
                          }
                          LODOP.PRINT();
                        })
                      }
                    });
                  }else{

                    _this.xAppTool.store.clear();
                    _this.$router.push({path: '/login'});
                  }
                })

              }else{
                let agent = navigator.userAgent.toLowerCase();
                if (agent.indexOf("win64") >= 0 || agent.indexOf("wow64") >= 0) {
                  _this.a_href = 'http://static.sysale.net/static/plugins/lodop/install_lodop64.exe'
                }
                else {
                  _this.a_href = 'http://static.sysale.net/static/plugins/lodop/install_lodop32.exe'
                }
                _this.dialogVisible = true;
              }
          },2000);
        },
        getTaskBtn: function(idx){
            let btns = [
                'mybtn-blue',
                'mybtn-purple',
                'mybtn-aquamarine',
                'mybtn-blue',
                'mybtn-warn',
                'mybtn-aquamarine',
                'mybtn-purple'
            ]
            let num = idx % 7
            if (num >= 0 && num <= 6) return btns[num]
            else return num[0]
        },
        getYesterday: function () {
            var d = new Date();
            d.setDate(d.getDate() - 1)
            this.yesterday=d
            return d
        },
        getPctDirect: function (val) {
            if (val == '1') return 'up'
            else if (val == '-1') return 'down'
            else return ''
        }
    },
    filters:{
        formatPct: function(val){
            var num = parseFloat(val);
            if(isNaN(num)) num = 0;
            return num.toFixed(0)
        }
    },
    created: function(){
        let self = this
        self.printDel();
        self.loadTasks();
        // （加载数据）今日工作
        self.tasks_loading = true
//        self.xFetch.post(self.xApi('/robot/monitor/homepage/getTasks'), {}).then(function (res) {
//            self.tasks_loading = false
//
//            if (res.data.code != '00') {
//                self.xEui.msg_error(res.data.text)
//                return
//            }
//            self.tasks = res.data.data;
//        });

        // （加载数据）昨日概况
        self.xFetch.post(self.xApi('/robot/monitor/homepage/getYesterdaySituation'), {}).then(function (res) {
            if (res.data.code != '00') {
                self.xEui.msg_error(res.data.text)
                return
            }
            self.ys = {
                "saleAmount": res.data.data.saleAmount,
                "payedAmount": res.data.data.payedAmount,
                "profitAmount": res.data.data.profitAmount,
                "orderNumber": res.data.data.orderNumber,
                "returnNumber": res.data.data.returnNumber,
                "customerNumber": res.data.data.customerNumber
            };
        });

        // （加载数据）商品信息
        self.gd_loading = true
        self.xFetch.post(self.xApi('/robot/monitor/homepage/getGoodsInfo'), {}).then(function (res) {
            self.gd_loading = false

            if (res.data.code != '00') {
                self.xEui.msg_error(res.data.text)
                return
            }
            self.gd = {
                "sellWell": res.data.data.sellWell,
                "sellSlow": res.data.data.sellSlow,
                "stockout": res.data.data.stockout,
                "expiration": res.data.data.expiration,
                "goods": res.data.data.goods,
            };
        });

        // （加载数据）订单提醒
        self.orderWarn_loading = true
        self.xFetch.post(self.xApi('/robot/monitor/homepage/getOrderWarn'), {}).then(function (res) {
            self.orderWarn_loading = false

            if (res.data.code != '00') {
                self.xEui.msg_error(res.data.text)
                return
            }
            self.orderWarn = {
                "list": res.data.data.list,
                "noRead": res.data.data.noRead
            };
        });

        // （加载数据）库存提醒
        self.stockWarn_loading = true
        self.xFetch.post(self.xApi('/robot/monitor/homepage/getStockWarn'), {}).then(function (res) {
            self.stockWarn_loading = false

            if (res.data.code != '00') {
                self.xEui.msg_error(res.data.text)
                return
            }
            self.stockWarn = {
                "list": res.data.data.list,
                "noRead": res.data.data.noRead
            };
        });

        // （加载数据）报表提醒
        self.reportWarn_loading = true
        self.xFetch.post(self.xApi('/robot/monitor/homepage/getReportWarn'), {}).then(function (res) {
            self.reportWarn_loading = false

            if (res.data.code != '00') {
                self.xEui.msg_error(res.data.text)
                return
            }
            self.reportWarn = {
                "list": res.data.data.list,
                "noRead": res.data.data.noRead
            };
        });
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    /*today-job-card*/
    .today-job-card{ padding: 2px 0px;position: relative }
    .today-job-card .mycard-title{ margin-right: 35px }
    .today-job-card .jobbtn{
        font-size: 14px;
        color: rgb(0, 97, 238);
        width: 130px;
        position: absolute;
        right: 0px;
        top: 0px;
        height: 100%;
        line-height: 80px;
        text-align: center;
        border-left: 1px solid #F2F5F8;
        cursor: pointer;
    }
    .jobbtn_s{
      display: flex;
      align-items: center;
      font-size: 14px;
      position: absolute;
      right: 132px;
      top: 0px;
      border:0;
    }
    .tasks_isStarts{
      width: 130px;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    /*ys-info*/
    .ys-info{ padding-top: 22px; padding-bottom: 10px}
    .ys-info:after{ display: table;content: '';clear: both }
    .ys-info .ys-info-item{ width: 16.6%;float: left ;text-align: center}
    .ys-info .ys-num{ font-size: 26px;color: #6739B7; }
    .ys-info .ys-title{font-size: 13px;color: #303133;font-weight: bolder;padding: 5px 0 14px 0 }
    .ys-info .ys-time{ width: 108px;margin: 0 auto;}
    .ys-info .ys-time:after{ display: table;content: '';clear: both }
    .ys-info .ys-time .t-l{ color: #909399;font-weight: bolder;font-size: 12px ;float: left }
    .ys-info .ys-time .t-r{ color: #909399;font-weight: bolder;font-size: 12px; float: right }
    .ys-info .ys-time .t-r img{ height: 8px;margin-right: 3px;display: none }
    .ys-info .ys-time .t-r .pct{ display: inline-block;text-align: right;width: 32px  }
    .ys-info .ys-time.up .img-up{ display: inline }
    .ys-info .ys-time.down .img-down{ display: inline }
    /*goods-type*/
    .goods-type{ margin-top: 10px }
    .goods-type .goods-type-item{
        float: left;
        width: 20%;
        min-width: 200px;
        padding-left: 10px;
        box-sizing:border-box;
    }
    .goods-type .goods-type-item:first-child{ padding-left: 0px }
    .goods-type .goods-type-item .el-card{ height: 190px }
    .goods-type .g-item-top{ }
    .goods-type .g-item-bottom{ margin-top: 10px;}
    .goods-type .g-item-top .el-card,
    .goods-type .g-item-bottom .el-card{ height: 90px }
    .goods-list{ font-size: 14px;color: #303133;list-style: none;padding: 0;margin: 0;padding-top: 30px }
    .goods-list li{ display: block;padding: 0 0 13px 40px;position: relative;overflow:hidden;text-overflow:ellipsis;white-space:nowrap }
    .goods-list li .num{ position: absolute;left: 8px;top: 0;font-size: 17px;font-weight: bolder }
    .goods-list li:nth-child(1) .num{ color: #FBBE3C; }
    .goods-list li:nth-child(2) .num{ color: #80D5D6; }
    .goods-list li:nth-child(3) .num{ color: #7AB1F9; }
    .goods-last-title{ font-size: 14px;color: #909399;font-weight: bolder; }
    .goods-last-num{
        font-size: 24px;
        color: #354052;
        padding-top: 6px ;
        white-space:nowrap;
        /*overflow: hidden;*/
        /*text-overflow: ellipsis;*/
        /*white-space: nowrap;*/
    }
    /*tips-type*/
    .tips-type{
        margin-top: 10px;
        display: flex;
        justify-content:center;
    }
    .tips-type .tips-type-item {
        width: 430px;
        /*float: left;*/
        margin-right: 20px;
    }
    .tips-type .tips-type-item:last-child{ margin-right: 0 }
    .tips-type .tips-type-item:first-child{ margin-left: 0px }
    .tx-list{ padding-top: 8px }
    .tx-list .tx-item{
        border: 1px solid #E8ECF2;
        border-radius: 4px;
        background: #fff;
        margin-top: 10px;
        padding: 10px ;
        font-size: 14px;
        color: #707090;
        position: relative;
    }
    .tx-list .tx-item .nmb{  font-size: 20px;font-weight: bold;display: flex; justify-content: center;align-items:center;height: 80px }
    .tx-list .tx-item .nmb .red{ color: #F56C6C }
    .tx-list .tx-item .tx-tag{ margin: 15px 0 }
    .tx-list .tx-item .tx-title{
        padding: 2px 0 15px 0;
    }
    .tx-list .tx-item .tx-body{ }
    .tx-list .tx-item.active .tx-tag{ color: #7895CF; }
    .tx-list .tx-item.active .tx-title{ color: #707090;font-weight: bolder }
    .tx-list .tx-item.active:after{
        display: table;
        content: '';
        position: absolute;
        top:-5px;
        left: -5px;
        width: 10px;
        height: 10px;
        background: #FF5867;
        border-radius: 50%;
    }
    .tx-list .time-tag{ }
    .tx-list [class*=" lbl-tag"], [class^=lbl-tag]{
        margin-left: 20px;
        width: 50px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        color: #fff;
        font-size: 12px;
        display: inline-block;
        background: #999;
        border-radius: 4px;
    }
    .tx-list .lbl-tag-blue{ background: #89acfa }
    .tx-list .lbl-tag-yellow{ background: #f3bf3e }
    .tx-list .cus-tag{ margin-left: 20px }
    .tx-list .f-right{ float: right }
</style>



// WEBPACK FOOTER //
// src/views/monitor/index.vue